<template>
  <div>
    <form data-vv-scope="custom-document" autocomplete="off" @submit.prevent>
      <h2 class="mb-10">Solicitud Gasto de Representación</h2>
      <div class="row form-group">
        <div class="col-12 col-md-6">
          <b-form-group label="Nombre Jefatura *">
            <list-user
              v-if="!bossInfoLoaded || directBoss == null"
              :disabled="loadingBossInfo"
              autocomplete
              class="w-100"
              data-cy="direct-boss"
              data-vv-as="nombre jefatura"
              name="directBoss"
              label=""
              :placeholder="directBossPlaceholder"
              v-model="directBoss"
              :danger="errors.has('custom-document.directBoss')"
              :danger-text="errors.first('custom-document.directBoss')"
              v-validate="{
                'required': !bossInfoLoaded || directBoss == null
              }"
              ref="functionary"
              filters-user-group="esOficina:N"
              @set-position="setDirectBoss"
            />
            <b-form-input
              v-else
              disabled
              data-cy="functionary"
              name="functionary"
              type="text"
              v-model="formData.directBoss"
              placeholder="Cargando..."
              :value="directBoss || 'Cargando...'"
            />
          </b-form-group>
        </div>
        <div class="col-12 col-md-6">
          <b-form-group label="Cargo Jefatura *">
            <b-form-input
              :state="errors.has('custom-document.position') ? false : null"
              data-cy="position"
              data-vv-as="cargo"
              name="position"
              type="text"
              v-model="formData.position"
              :disabled="loadingBossInfo
                || !formData.directBoss
                || disablePositionInput
              "
              :placeholder="positionPlaceholder"
              v-validate="'required'"
            />
            <div
              v-if="errors.has('custom-document.position')"
              class="con-text-validation span-text-validation-danger v-enter-to"
            >
              <span class="span-text-validation">
                {{ errors.first('custom-document.position') }}
              </span>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-12">
          <b-form-group label="Actividad *">
            <b-form-input
              :state="errors.has('custom-document.activity') ? false : null"
              data-cy="activity"
              data-vv-as="actividad"
              name="activity"
              type="text"
              v-model="formData.activity"
              v-validate="'required'"
            />
            <div
              v-if="errors.has('custom-document.activity')"
              class="con-text-validation span-text-validation-danger v-enter-to"
            >
              <span class="span-text-validation">
                {{ errors.first('custom-document.activity') }}
              </span>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-12 col-md-6">
          <b-form-group label="Fecha Ejecución Actividad *">
            <date-picker
              :input-class="{
                'mx-input':true,
                'border-danger':errors.has('custom-document.activityExecDate')
              }"
              data-cy="activity-execution-date"
              class="w-100"
              name="activityExecDate"
              format="DD-MM-YYYY"
              value-type="YYYY-MM-DD"
              data-vv-as="fecha ejecución actividad"
              :danger="errors.has('custom-document.activityExecDate')"
              :danger-text="errors.first('custom-document.activityExecDate')"
              v-validate="'required'"
              v-model="formData.activityExecDate"
            />
            <div
              v-if="errors.has('custom-document.activityExecDate')"
              class="con-text-validation span-text-validation-danger v-enter-to"
            >
              <span class="span-text-validation">
                {{ errors.first('custom-document.activityExecDate') }}
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-12 col-md-6">
          <b-form-group label="Hora Ejecución Actividad *">
            <date-picker
              :input-class="{
                'mx-input':true,
                'border-danger':errors.has('custom-document.activityExecTime')
              }"
              type="time"
              data-cy="activity-execution-time"
              class="w-100"
              name="activityExecTime"
              format="HH:mm"
              value-type="HH:mm"
              data-vv-as="hora ejecución actividad"
              :danger="errors.has('custom-document.activityExecTime')"
              :danger-text="errors.first('custom-document.activityExecTime')"
              v-validate="'required'"
              v-model="formData.activityExecTime"
            />
            <div
              v-if="errors.has('custom-document.activityExecTime')"
              class="con-text-validation span-text-validation-danger v-enter-to"
            >
              <span class="span-text-validation">
                {{ errors.first('custom-document.activityExecTime') }}
              </span>
            </div>
          </b-form-group>
        </div>
      <div class="row form-group">
      </div>
        <div class="col-12">
          <b-form-group label="Lugar de Ejecución Actividad *">
            <b-form-input
              :state="errors.has('custom-document.activityExecPlace') ? false : null"
              data-cy="activity-exec-place"
              data-vv-as="lugar de ejecución"
              name="activityExecPlace"
              type="text"
              v-model="formData.activityExecPlace"
              v-validate="'required'"
            />
            <div
              v-if="errors.has('custom-document.activityExecPlace')"
              class="con-text-validation span-text-validation-danger v-enter-to"
            >
              <span class="span-text-validation">
                {{ errors.first('custom-document.activityExecPlace') }}
              </span>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-12">
          <b-form-group label="Que Autoridades Participan (ingresar una autoridad por línea) *">
            <b-form-textarea
              max
              maxlength="5000"
              :rows="formData.authorities.length + 1 || 2"
              :danger="errors.has('custom-document.authorities')"
              :danger-text="errors.first('custom-document.authorities')"
              data-cy="authorities"
              data-vv-as="que autoridades participan"
              v-model="authoritiesStr"
              name="authorities"
              v-validate="'required'"
              @input="(value) => {
                authoritiesStr = value;
                formData.authorities = value.split('\n').filter((authority) => authority.trim());
              }"
            />
            <div
              v-if="errors.has('custom-document.authorities')"
              class="con-text-validation span-text-validation-danger v-enter-to"
            >
              <span class="span-text-validation">
                {{ errors.first('custom-document.authorities') }}
              </span>
            </div>
          </b-form-group>
          <div v-if="formData.authorities.length">
            <b>Autoridades ingresadas: </b>
            <ul>
              <li v-for="authority in formData.authorities" :key="authority">
                - {{ authority }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-12">
          <b-form-group label="Tipos de Requerimiento *">
            <div
              v-if="loadingRequirementTypes"
              class="text-center flex items-center gap-2 justify-content-center"
            >
              Cargando tipos de requerimiento...
              <b-spinner label="Cargando..."></b-spinner>
            </div>
            <b-form-checkbox-group
              class="mt-3"
              id="requirementTypes"
              name="requirementTypes"
              data-cy="requirement-types"
              data-vv-as="tipo de requerimiento"
              v-model="formData.requirementTypes"
              :options="requirementTypeOptions"
              v-validate="'required'"
              switches
            />
            <b-form-input
              v-if="otherTextFieldEnabled"
              :state="errors.has('custom-document.otherRequirement') ? false : null"
              data-cy="other-requirement"
              data-vv-as="otro"
              name="otherRequirement"
              type="text"
              placeholder="Ingrese otro tipo de requerimiento"
              v-model="formData.otherRequirement"
              v-validate="'required'"
            />
            <div
              v-if="errors.has('custom-document.otherRequirement')"
              class="con-text-validation span-text-validation-danger v-enter-to"
            >
              <span class="span-text-validation">
                {{ errors.first('custom-document.otherRequirement') }}
              </span>
            </div>
            <div
              v-if="errors.has('custom-document.requirementTypes')"
              class="con-text-validation span-text-validation-danger v-enter-to"
            >
              <span class="span-text-validation">
                {{ errors.first('custom-document.requirementTypes') }}
              </span>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <b-form-group label="Especificaciones Técnicas (EETT) *">
            <editor-text
              class="-mb-4"
              :danger="errors.has('custom-document.technicalSpecs')"
              :danger-text="errors.first('custom-document.technicalSpecs')"
              data-cy="technical-specs"
              data-vv-as="especificaciones técnicas"
              name="technicalSpecs"
              v-model="formData.technicalSpecs"
              v-validate="'required'"
              with-counter
            />
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <b-form-group label="Presupuesto Disponible *">
            <InputCurrency
              ref="availableBudget"
              label=""
              :options="{
                locale: 'es-CL',
                currency:'CLP',
                hideGroupingSeparatorOnFocus: false,
                currencyDisplay: 'hidden',
                precision: {
                  min: 0,
                  max: 2
                }
              }"
              v-model="formData.availableBudget"
              id="availableBudget"
              name="availableBudget"
              data-cy="available-budget"
              :disabled="formData.budgetNotRequired"
              :state="errors.has('custom-document.availableBudget') ? false : null"
              :danger="errors.has('custom-document.availableBudget')"
              :danger-text="errors.first('custom-document.availableBudget')"
            />
            <b-form-checkbox
              v-model="formData.budgetNotRequired"
              data-cy="budget-not-required"
              class="m-0"
              switch
              @change="resetBudget()"
            >
              Según cotización
            </b-form-checkbox>
          </b-form-group>
        </div>
      </div>
      <div class="mt-5">
        <span class="italic">
          <b>( * )</b>
          En caso de detallar mayores antecedentes, remitir anexo con Especificaciones Técnicas
        </span>
      </div>
      <div class="row gap-y-2 mt-2">
        <upload-file
          data-cy="annex-file"
          permission="*"
          accept="application/pdf, .doc, .docx, .xlsv, .ppt"
          text="Adjuntar anexo desde equipo"
          v-model="annexFile"
          upload-to="ed"
          container-class="col-12 col-md-6 col-lg-6 col-xl-3"
          button-class="btn-block flex-1"
          @input="addAnnexFile"
        />
        <div class="col-12 col-md-6 col-lg-6 col-xl-3">
          <b-button
            variant="secondary"
            class="btn-block"
            data-cy="annex-file-repository"
            v-has-permission="'ED060'"
            v-b-modal="'add-annex-file-repository'"
          >
            Adjuntar anexo desde repositorio
          </b-button>
        </div>
        <div
          class="col-12 col-sm-6 col-md-4 col-xl-3"
          v-for="file in annexFiles"
          :key="file.id"
        >
          <div class="d-flex align-items-center">
            <vs-icon icon="description" size="25px" color="primary"/>
            <b class="text-truncate w-100 text-center">{{ file.name }}</b>
            <vs-button
              data-cy="remove-annex-file"
              color="danger"
              type="flat"
              icon="clear"
              @click="removeAnnexFile(file.id)"
            />
          </div>
        </div>
      </div>
      <div
        v-if="!!error.message"
        class="con-text-validation span-text-validation-danger
              vs-input--text-validation-span v-enter-to text-right"
      >
        <span class="span-text-validation">
          {{ error.message }}
        </span>
      </div>
    </form>
    <div class="row justify-end">
      <vs-button
        class="mt-5 mr-5"
        data-cy="cancel"
        @click="back()"
        color="primary"
        :disabled="saving"
      >
        Cancelar
      </vs-button>
      <vs-button
        class="mt-5 mr-5"
        data-cy="save"
        @click="save()"
        color="success"
        :disabled="saving"
      >
        Crear
        <span
          v-show="saving"
          class="spinner-border spinner-border-sm text-primary"
        />
      </vs-button>
    </div>
    <!--<SelectDocRepository
      modal-id="add-annex-file-repository"
      :add-file="addAnnexFile"
      :files="annexFiles"
      :remove-file="removeAnnexFile"
      :max-files="1"
    />-->
    <repository-selector
      modal-id="add-annex-file-repository"
      :add-file="addAnnexFile"
      :files="annexFiles"
      :remove-file="removeAnnexFile"
      :max-files="1"
    />
  </div>
</template>

<script>

import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

import DatePicker from 'vue2-datepicker';
import { mapActions, mapGetters } from 'vuex';
import { BFormCheckbox } from 'bootstrap-vue';

import { ioCreateCustomDocument, ioGetCustomDocument } from '@/febos/servicios/api/customDocuments.api';
import EditorText from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/EditorText';
import UploadFile from '@/febos/global/_vue/componentes/UploadFile';
import SelectDocRepository from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/SelectDocRepository';
import { ioListOptions } from '@/febos/servicios/api/herramientas.api';
import { getUserById } from '@/febos/servicios/api/usuarios.api';
import InputCurrency from '@/components/InputCurrency';
import ListUser from '@/febos/chile/lists/components/ListUser';
import RepositorySelector from "@/febos/global/customDocuments/components/repository-selector/RepositorySelector.vue";

export default {
  name: 'SOGR',
  components: {
    RepositorySelector,
    ListUser,
    BFormCheckbox,
    InputCurrency,
    EditorText,
    UploadFile,
    DatePicker,
    SelectDocRepository
  },
  data() {
    return {
      documentSelectorEnabled: false,
      loadingRequirementTypes: false,
      requirementTypeOptions: [],
      annexFile: {},
      annexFiles: [],
      directBoss: null,
      loadingBossInfo: false,
      bossInfoLoaded: false,
      disablePositionInput: false,
      authoritiesStr: '',
      formData: {
        directBoss: '',
        position: '',
        activity: '',
        activityExecDate: '',
        activityExecTime: '',
        activityExecPlace: '',
        authorities: [],
        requirementTypes: [],
        otherRequirement: '',
        technicalSpecs: '',
        availableBudget: null,
        budgetNotRequired: false,
      },
      saving: false,
      error: {
        message: ''
      }
    };
  },
  computed: {
    ...mapGetters('Management', [
      'workerData',
    ]),
    ...mapGetters('Usuario', [
      'currentUser',
    ]),
    ...mapGetters('Empresas', [
      'company',
    ]),
    otherTextFieldEnabled() {
      return this.formData.requirementTypes && this.formData.requirementTypes.includes('Otro');
    },
    directBossPlaceholder() {
      return this.loadingBossInfo ? 'Cargando...' : 'Selecciona una jefatura';
    },
    positionPlaceholder() {
      if (this.loadingBossInfo) return 'Cargando...';
      return (this.bossInfoLoaded && !this.formData.position)
        ? 'Ingresa un cargo'
        : 'Selecciona una jefatura';
    }
  },
  methods: {
    ...mapActions('Management', [
      'getWorkerData',
    ]),
    back() {
      /* eslint-disable no-restricted-globals */
      history.back();
    },
    async loadBossInformation() {
      this.loadingBossInfo = true;
      this.bossInfoLoaded = false;
      try {
        const TIPO_RESPUESTA_MAP = 2;
        await this.getWorkerData({
          tipoRespuesta: TIPO_RESPUESTA_MAP,
          elementoId: this.currentUser.id,
          referenciaId: this.company.id,
          filtros: 'nombre:JEFATURA_ID,JEFATURA_CARGO'
        });

        let jefe = null;
        if (this.workerData.JEFATURA_ID?.valor) {
          jefe = await getUserById(this.workerData.JEFATURA_ID?.valor);
        }

        if (!jefe || !jefe.data || !jefe.data.usuario) return;
        const usuarioJefe = jefe.data.usuario;

        if (this.workerData.JEFATURA_CARGO?.valor) {
          this.formData.position = this.workerData.JEFATURA_CARGO?.valor;
          this.disablePositionInput = true;
        } else if (usuarioJefe.cargo) {
          this.formData.position = usuarioJefe.cargo;
          this.disablePositionInput = true;
        } else {
          this.formData.position = '';
          this.disablePositionInput = false;
        }

        if (usuarioJefe.nombre) {
          this.directBoss = usuarioJefe.nombre;
          this.formData.directBoss = this.directBoss;
          this.bossInfoLoaded = true;
        } else {
          this.directBoss = null;
          this.formData.directBoss = null;
        }
      } finally {
        this.loadingBossInfo = false;
      }
    },
    async loadRequirementTypes() {
      try {
        this.loadingRequirementTypes = true;
        const response = await ioListOptions({
          grupoOpcion: 'io.requerimientos.gore',
          filtros: 'deshabilitado:0'
        });
        const { opciones } = response.data;
        this.requirementTypeOptions = opciones.map((option) => ({
          value: option.valor,
          text: option.descripcion,
          orden: option.orden
        })).concat([
          { value: 'Otro', text: 'Otro', orden: opciones.length + 1 }
        ]).sort(({ orden: x }, { orden: y }) => x - y);
      } finally {
        this.loadingRequirementTypes = false;
      }
    },
    async setDirectBoss(boss) {
      if (boss.position && boss.position !== '') {
        this.formData.position = boss.position;
        this.disablePositionInput = true;
      } else {
        this.formData.position = '';
        this.disablePositionInput = false;
      }

      this.formData.directBoss = boss.label;
    },
    resetBudget() {
      this.formData.availableBudget = 0;
    },
    async addFile(fileArray, file) {
      if (!Object.keys(file).length) return;

      if (file.failed) this.error.message = 'La carga del archivo falló, inténtalo de nuevo';

      fileArray.push(file);
      console.log(fileArray);
      this.error.message = '';
    },
    async addAnnexFile(file) {
      await this.addFile(this.annexFiles, file || this.annexFile);
    },
    removeAnnexFile(id) {
      this.annexFiles = this.annexFiles
        .filter((file) => file.id !== id);
    },
    async generatePdf(id) {
      this.$bvToast.toast(
        'Generando archivo PDF',
        {
          title: 'En camino...',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 5000
        }
      );
      const response = await ioGetCustomDocument('SOGR', id, { pdf: 'si' });
      this.$bvToast.toast(
        'Archivo generado',
        {
          title: 'Listo!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 2000
        }
      );
      window.open(response.data.pdf, '_blank');
      this.back();
    },
    validateBudget() {
      this.$validator.errors.remove('availableBudget', 'custom-document');

      if (this.formData.availableBudget === null) {
        this.$validator.errors.add({
          field: 'availableBudget',
          msg: 'El presupuesto disponible es requerido',
          scope: 'custom-document',
        });
        return;
      }

      if (this.formData.availableBudget <= 0) {
        this.$validator.errors.add({
          field: 'availableBudget',
          msg: 'El presupuesto disponible debe ser mayor a 0',
          scope: 'custom-document',
        });
      }
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);

      if (!result) {
        this.$vs.notify({
          title: 'Ups!',
          text: 'Revisa los campos marcados en rojo',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'bottom-right',
          time: 5000,
        });
      }

      return !!result;
    },
    async save() {
      const isValid = await this.validateForm('custom-document');
      if (!isValid) return;

      this.error.message = '';
      this.saving = true;

      try {
        this.$bvToast.toast(
          'Guardando documento',
          {
            title: 'En camino...',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 2000
          }
        );
        const payload = {
          type: this.$route.params.type,
          query: {
            numerar: 'si',
            ...this.$route.query
          },
          formData: {
            ...this.formData,
            ...(this.annexFiles.length && {
              attachments: [...this.annexFiles]
            }),
            checkedRequirementsType: this.requirementTypeOptions.map((type) => ({
              value: type.value,
              checked: this.formData.requirementTypes.includes(type.value)
            })),
          },
        };
        const response = await ioCreateCustomDocument(payload);
        await this.generatePdf(response.data.document.id);
      } finally {
        this.saving = false;
      }
    }
  },
  created() {
    this.loadRequirementTypes();
    this.loadBossInformation();
  },
  mounted() {
    this.formData.availableBudget = 0;
  },
  watch: {
    'formData.availableBudget': {
      handler() {
        if (!this.formData.budgetNotRequired) this.validateBudget();
      },
      deep: true
    },
    'formData.budgetNotRequired': {
      handler(budgetNotRequired) {
        if (budgetNotRequired) {
          this.$validator.errors.remove('availableBudget', 'custom-document');
        } else {
          this.validateBudget();
        }
      }
    }
  }
};
</script>
<style>
.custom-control.custom-control-inline.custom-switch {
  width: 48%;
  margin-bottom: 0.5rem;
}
</style>
